import { useState, useEffect } from 'react';
import api from '../../../services/api';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function AprovadoSC() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/sc`);
                setData(response.data.content);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados das Solicitações de compra:", error);
            }
        }
        fetchData();
    }, [page]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    const handlePdfClick = async (id) => {
        try {
            const response = await api.get(`/sc/${id}/af`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error(error);
            mostrarAlerta("Erro ao gerar autorização de fornecimento!", "error");
        }
    };

    return (
        <PageContainer>
            <PageHeader title="Solicitações de compra aprovadas" />

            <Grid container spacing={2}>
                {data.filter(sc => sc.status === "Aprovado").map((sc, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card>
                            <CardActionArea onClick={() => handlePdfClick(sc.id)}>
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{sc.motivo}</Typography>
                                    <Typography variant="body2" color="text.secondary">Número: {sc.numero}</Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default AprovadoSC;
